import { defineStore } from 'pinia'
import { ref } from 'vue'
import { serverOffset } from '../lib/serverTime'

/**
 * One shared "now" so every wait time on screen ticks together (1 s). It is the SERVER's time (this computer's clock
 * + the offset read from API answers, lib/serverTime.ts): ทักตาม due, the follow-up window and "เกินเวลา" are the
 * server's times, so a computer clock that is off does not move rows early or late. Tests set it by hand.
 */
export const useClock = defineStore('clock', () => {
  const now = ref(Date.now() + serverOffset())
  let timer: ReturnType<typeof setInterval> | null = null

  function start(everyMs = 1000): void {
    stop()
    now.value = Date.now() + serverOffset()
    timer = setInterval(() => {
      now.value = Date.now() + serverOffset()
    }, everyMs)
  }

  function stop(): void {
    if (timer) clearInterval(timer)
    timer = null
  }

  function set(ms: number): void {
    now.value = ms
  }

  return { now, start, stop, set }
})
